import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'helo-sauna-volume-calculator',
    templateUrl: './helo-sauna-volume-calculator.component.html',
    styleUrl: './helo-sauna-volume-calculator.component.css',
    standalone: false
})
export class HeloSaunaVolumeCalculatorComponent {
  public calculatedVolume: number;
  form: FormGroup;

  ngOnInit() {
    this.form = new FormGroup({
      depth: new FormControl(0, [Validators.required, Validators.min(0)]),
      width: new FormControl(0, [Validators.required, Validators.min(0)]),
      height: new FormControl(0, [Validators.required, Validators.min(0)]),
      uninsulated: new FormControl(0, [Validators.min(0)]),
      lasiovi: new FormControl(false),
      log: new FormControl(false)
    })
  }

  public shoot() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }
    const { depth, width, height, log, lasiovi, uninsulated } = this.form.getRawValue();
    this.calculatedVolume = depth * width * height / 1000000;
    if (log) {
      this.calculatedVolume *= 1.5;
    }
    if (lasiovi) {
      this.calculatedVolume += 2;
    }
    if (uninsulated > 0) {
      this.calculatedVolume += uninsulated * 1.2;
    }
  }
}
